/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * User phone number information
 * @export
 * @interface UserPhoneNumberDto
 */
export interface UserPhoneNumberDto {
    /**
     * 
     * @type {boolean}
     * @memberof UserPhoneNumberDto
     */
    primary?: boolean;
    /**
     * Phone number ID
     * @type {string}
     * @memberof UserPhoneNumberDto
     */
    id?: string;
    /**
     * Phone number in E.164 format
     * @type {string}
     * @memberof UserPhoneNumberDto
     */
    phoneNumber?: string;
    /**
     * Country code extracted from phone number
     * @type {string}
     * @memberof UserPhoneNumberDto
     */
    countryCode?: string;
    /**
     * Type of phone number
     * @type {string}
     * @memberof UserPhoneNumberDto
     */
    type?: UserPhoneNumberDtoTypeEnum;
    /**
     * Whether this is the primary phone number for the user
     * @type {boolean}
     * @memberof UserPhoneNumberDto
     */
    isPrimary?: boolean;
    /**
     * Whether this phone number is active
     * @type {boolean}
     * @memberof UserPhoneNumberDto
     */
    active?: boolean;
    /**
     * Whether this phone number has been verified
     * @type {boolean}
     * @memberof UserPhoneNumberDto
     */
    verified?: boolean;
    /**
     * Timestamp when phone number was verified
     * @type {Date}
     * @memberof UserPhoneNumberDto
     */
    verifiedAt?: Date;
    /**
     * Optional label/description for the phone number
     * @type {string}
     * @memberof UserPhoneNumberDto
     */
    label?: string;
    /**
     * When the phone number was created
     * @type {Date}
     * @memberof UserPhoneNumberDto
     */
    createdAt?: Date;
    /**
     * When the phone number was last updated
     * @type {Date}
     * @memberof UserPhoneNumberDto
     */
    updatedAt?: Date;
}


/**
 * @export
 */
export const UserPhoneNumberDtoTypeEnum = {
    Mobile: 'MOBILE',
    Work: 'WORK',
    Home: 'HOME',
    Other: 'OTHER'
} as const;
export type UserPhoneNumberDtoTypeEnum = typeof UserPhoneNumberDtoTypeEnum[keyof typeof UserPhoneNumberDtoTypeEnum];


/**
 * Check if a given object implements the UserPhoneNumberDto interface.
 */
export function instanceOfUserPhoneNumberDto(value: object): value is UserPhoneNumberDto {
    return true;
}

export function UserPhoneNumberDtoFromJSON(json: any): UserPhoneNumberDto {
    return UserPhoneNumberDtoFromJSONTyped(json, false);
}

export function UserPhoneNumberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPhoneNumberDto {
    if (json == null) {
        return json;
    }
    return {
        
        'primary': json['primary'] == null ? undefined : json['primary'],
        'id': json['id'] == null ? undefined : json['id'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'type': json['type'] == null ? undefined : json['type'],
        'isPrimary': json['isPrimary'] == null ? undefined : json['isPrimary'],
        'active': json['active'] == null ? undefined : json['active'],
        'verified': json['verified'] == null ? undefined : json['verified'],
        'verifiedAt': json['verifiedAt'] == null ? undefined : (new Date(json['verifiedAt'])),
        'label': json['label'] == null ? undefined : json['label'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function UserPhoneNumberDtoToJSON(json: any): UserPhoneNumberDto {
    return UserPhoneNumberDtoToJSONTyped(json, false);
}

export function UserPhoneNumberDtoToJSONTyped(value?: UserPhoneNumberDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primary': value['primary'],
        'id': value['id'],
        'phoneNumber': value['phoneNumber'],
        'countryCode': value['countryCode'],
        'type': value['type'],
        'isPrimary': value['isPrimary'],
        'active': value['active'],
        'verified': value['verified'],
        'verifiedAt': value['verifiedAt'] == null ? undefined : ((value['verifiedAt']).toISOString()),
        'label': value['label'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

